import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog, RoutalSelect, RoutalSelectMultiSelectOption, VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import { EventType } from '../../../../../domain/webhook/EventType';
import { Webhook } from '../../../../../domain/webhook/Webhook';
import { useTestWebhook } from '../../../../../hooks/webhooks/useTestWebhook';
import Button from '../../../../../react-components/Button';
import Text from '../../../../../react-components/Text';

interface TestWebhookDialogProps {
  webhook: Webhook;
  onClose: () => void;
}

export const TestWebhookDialog = ({ webhook, onClose }: TestWebhookDialogProps) => {
  const { run: testWebhook } = useTestWebhook(webhook);
  const [activeEvent, setActiveEvent] = useState<EventType>(webhook.enabled_events[0]);

  return (
    <RoutalDialog
      open
      dialogProps={{
        maxWidth: `sm`,
      }}
      onCloseDialog={onClose}
      titleContent={<Text variant="h6" intlId="settings.developers.webhooks.test_webhook_title" />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button variant="flat" intlId="cancel" onClick={onClose} />
          <HSpacer small />
          <Button
            intlId="settings.developers.webhooks.test_webhook_button"
            onClick={() => {
              testWebhook(activeEvent);
              onClose();
            }}
          />
        </Grid>
      }
    >
      <Grid container direction="column">
        <Grid style={{ minWidth: `300px`, padding: `16px` }}>
          <Grid item>
            <Text intlId="settings.developers.webhooks.test_webhook_body" />
          </Grid>

          <VSpacer large />

          <Grid item>
            <RoutalSelect
              id="filter-routes-unassigned"
              style={{
                justifyContent: `space-between`,
              }}
              popoverProps={{
                options: webhook.enabled_events.map(
                  (event: EventType, idx: number): RoutalSelectMultiSelectOption => ({
                    key: event,
                    checked: activeEvent === event,
                    onClick: () => {
                      setActiveEvent(event);
                    },
                    content: (
                      <Text style={{ cursor: `pointer` }} intlId={`settings.developers.webhooks.events.${event}`} />
                    ),
                  })
                ),
              }}
            >
              <Text style={{ textAlign: `left` }} intlId={`settings.developers.webhooks.events.${activeEvent}`} />
            </RoutalSelect>
          </Grid>
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
